// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "CreditLinkagePage__textCenter__su7IV";
export const creditLinkagePage = "CreditLinkagePage__creditLinkagePage__TlhcK";
export const main = "CreditLinkagePage__main__YLfhA";
export const linkage = "CreditLinkagePage__linkage__jG5qO";
export const linked = "CreditLinkagePage__linked__HBs-Z";
export const footer = "CreditLinkagePage__footer__YvvvQ";